export default __webpack_public_path__ + "static/media/promo_07.4511ab59.jpg";